module.exports = __webpack_public_path__ + "ef134d91018b4a5b65882ae4a1bf39c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatars/avatar-2.png
// module id = 306
// module chunks = 1